import update from 'immutability-helper';
import { combineActions } from 'redux-actions';

import * as actions from 'constants/surveyList/SurveyListActions';

export default {
  [actions.SORT_SURVEY_LIST_COLUMN]: (
    state,
    { payload: { listId, field, order } },
  ) =>
    update(state, {
      [listId]: {
        sortBy: {
          $set: field,
        },
        sortOrder: {
          $set: order,
        },
      },
    }),
  [actions.SET_SURVEY_LIST_PREVIEW_TEXT]: (
    state,
    { payload: { listId, text } },
  ) =>
    update(state, {
      [listId]: {
        searchPreviewText: {
          $set: text,
        },
      },
    }),
  [actions.GET_SURVEY_LIST_PREVIEW_OPTIONS_REQUEST]: (
    state,
    { listId, reset },
  ) =>
    update(state, {
      [listId]: {
        isSearchPreviewItemsLoading: {
          $set: reset,
        },
      },
    }),
  [actions.GET_SURVEY_LIST_PREVIEW_OPTIONS_SUCCESS]: (
    state,
    { listId, data: { count } },
  ) =>
    update(state, {
      [listId]: {
        searchPreviewSurveyCount: {
          $set: count,
        },
      },
    }),
  [actions.GET_SURVEY_LIST_PREVIEW_OPTIONS_FAILURE]: (state, { listId }) =>
    update(state, {
      [listId]: {
        isSearchPreviewItemsLoading: {
          $set: false,
        },
      },
    }),
  [actions.SET_SURVEY_LIST_PREVIEW_OPTIONS]: (
    state,
    { payload: { listId, options } },
  ) =>
    update(state, {
      [listId]: {
        searchPreviewItems: {
          $set: options,
        },
        isSearchPreviewItemsLoading: {
          $set: false,
        },
      },
    }),
  [actions.SET_SURVEY_LIST_PREVIEW_OPTIONS_COUNT]: (
    state,
    { payload: { listId, count } },
  ) =>
    update(state, {
      [listId]: {
        searchPreviewSurveyCount: {
          $set: count,
        },
      },
    }),
  [actions.ADD_SURVEY_LIST_PREVIEW_OPTIONS]: (
    state,
    { payload: { listId, options, offset, limit } },
  ) =>
    update(state, {
      [listId]: {
        searchPreviewItems: {
          $splice: [[offset, limit, ...options]],
        },
        isSearchPreviewItemsLoading: {
          $set: false,
        },
      },
    }),
  [combineActions(
    actions.DELETE_SURVEY_SUCCESS,
    actions.BATCH_SURVEYS_STATUS_SUCCESS,
  )]: (state, { listId, itemIds }) =>
    update(state, {
      [listId]: {
        selectedItems: {
          $unset: itemIds,
        },
      },
    }),
};
